export function getFilters(filters) {
  return filters.reduce((acc, curr) => {
    acc[`filter[${curr}]`] = true
    return acc
  }, {})
}
